import RestClient from "./rest-client"
import CbError from "./cb-error.js"
import CBNotification from "@/models/cb-notification"

var constructQueryParams = function(allowed, params) {
  return allowed.reduce((o, p) => {
    if(params[p]) {
      o += `${p}=${params[p]}&`;
    }
    return o;
  }, "");
}

const apis = [
  {
    name: "estimates",
    actions: [
      {
        name: "create_subscription",
        method: "post",
        endpointFn: (params) => `/api/v2/estimates/create_subscription?hp_token=${params.hp_token}`,
        set_locale: true
      },
      {
        name: "update_subscription",
        method: "post",
        endpointFn: (params) => {
          var query = constructQueryParams(['hp_token'], params);
          return `/api/v2/estimates/update_subscription?${query}`;
        },
        auth: true,
        set_locale: true
      },
      {
        name: "recurring",
        method: "get",
        endpointFn: (params) => `/api/v2/subscriptions/${params.id}/recurring_subscription_estimate?skip_one_time_coupon=true`,
        set_locale: true
      }
    ]
  },
  {
    name: "paypal",
    actions: [
      {
        name: "setup_authorization",
        method: "post",
        endpoint: "/api/internal/paypal/setup_authorization",
        headers: {
          "X-Requested-With": "XMLHttpRequest"
        }
      },
      {
        name: "fetch_details",
        method: "post",
        endpoint: "/api/internal/paypal/token_info",
        headers: {
          "X-Requested-With": "XMLHttpRequest"
        }
      }
    ]
  },
  {
    name: "gocardless",
    actions: [
      {
        name: "create_redirect",
        method: "post",
        endpoint: "/api/internal/gocardless/create_redirect",
        headers: {
          "X-Requested-With": "XMLHttpRequest"
        }
      }
    ]
  },
  {
    name: "braintree",
    actions: [
      {
        name: "generate_client_token",
        method: "post",
        endpoint: "/api/internal/braintree/generate_client_token",
        headers: {
          "X-Requested-With": "XMLHttpRequest"
        }
      }
    ]
  },
  {
    name: "plaid",
    actions: [
      {
        name: "exchange_token",
        method: "post",
        endpoint: "/api/internal/plaid/exchange_token",
        headers: {
          "X-Requested-With": "XMLHttpRequest"
        }
      }
    ]
  },
  {
    name: "stripe",
    actions: [
      {
        name: "retrieve_token",
        method: "post",
        endpoint: "/api/internal/stripe/retrieve_token",
        headers: {
          "X-Requested-With": "XMLHttpRequest"
        }
      },
      {
        name: "verify_bank_account",
        method: "post",
        endpoint: "/api/internal/bank_account/verify",
        headers: {
          "X-Requested-With": "XMLHttpRequest"
        }
      }
    ]
  },
  {
    name: "hosted_pages",
    actions: [
      {
        name: "get",
        method: "get",
        endpoint: '/api/internal/hosted_page/retrieve',
        headers: {
          "X-Requested-With": "XMLHttpRequest"
        }
      }

    ]
  },
  {
    name: "plans",
    actions: [
      {
        name: "get",
        method: "get",
        endpointFn: (params) => `/api/v2/plans/${params.id}`,
        set_locale: true
      },
      {
        name: "list",
        method: "get",
        endpoint: "/api/v2/plans",
        set_locale: true
      },
      {
        name: "fetch_other_products",
        method: "get",
        endpoint: '/api/internal/products/list',
        headers: {
          "X-Requested-With": "XMLHttpRequest"
        }
      }
    ]
  },
  {
    name: "addons",
    actions: [
      {
        name: "get",
        method: "get",
        endpoint: '/api/v2/addons',
        set_locale: true
      }
    ]
  },
  {
    name: "payment_sources",
    actions: [
      {
        name: "get",
        method: "get",
        endpointFn: (params) => `/api/v2/payment_sources/${params.id}`,
        set_locale: true,
        auth: true
      }
    ]
  },
  {
    name: "subscriptions",
    actions: [
      {
        name: "create",
        method: "post",
        endpointFn: (params) => `/api/v2/subscriptions?hp_token=${params.hp_token}`
      },
      {
        name: "get",
        method: "get",
        endpointFn: (params) => `/api/v2/subscriptions/${params.id}`,
        set_locale: true
      },
      {
        name: "update",
        method: "post",
        endpointFn: (params) => {
          var query = constructQueryParams(['hp_token', 'resource'], params);
          return `/api/v2/subscriptions/${params.id}?${query}`
        },
        auth: true
      },
      {
        name: "override_billing_profile",
        method: "post",
        endpointFn: (params) => `/api/v2/subscriptions/${params.id}/override_billing_profile`,
        auth: true
      },
      {
        name: "update_bulk",
        method: "post",
        endpointFn: (params) => `/api/internal/subscriptions/${params.id}?hp_token=${params.hp_token}`,
        auth: true,
        headers: {
          "X-Requested-With": "XMLHttpRequest"
        }
      },
      {
        name: "cancel",
        method: "post",
        endpointFn: (params) => `/api/v2/subscriptions/${params.id}/cancel`,
        auth: true
      },
      {
        name: "reactivate",
        method: "post",
        endpointFn: (params) => `/api/v2/subscriptions/${params.id}/reactivate`,
        auth: true
      },
      {
        name: "scheduled_changes",
        method: "get",
        endpointFn: (params) => `/api/v2/subscriptions/${params.id}/renewal_estimate?include_delayed_charges=false&use_existing_balances=false`,
        auth: true,
        set_locale: true
      },
      {
        name: "remove_scheduled_changes",
        method: "post",
        endpointFn: (params) => `/api/v2/subscriptions/${params.id}/remove_scheduled_changes`,
        auth: true
      }
    ]
  },
  {
    name: "customers",
    actions: [
      {
        name: "get",
        method: "get",
        endpointFn: (params) => `/api/v2/customers/${params.id}`,
        auth: true,
        set_locale:true
      },
      {
        name: "update",
        method: "post",
        endpointFn: (params) => {
          var query = constructQueryParams(['hp_token'], params);
          return `/api/v2/customers/${params.id}?${query}`
        },
        auth: true,
        ignore_locale: true

      },
      {
        name: "shipping_address_list",
        method: "get",
        endpoint: "/api/v2/subscriptions",
        auth: true
      },
      {
        name: "payment_method_list",
        method: "get",
        endpoint: "/api/v2/payment_sources",
        auth: true
      },
      {
        name: "create_card_payment_source",
        method: "post",
        endpointFn: (params) => `/api/v2/payment_sources/create_card?hp_token=${params.hp_token}`,
        auth: true
      },
      {
        name: "create_bank_account_payment_source",
        method: "post",
        endpointFn: (params) => `/api/v2/payment_sources/create_bank_account?hp_token=${params.hp_token}`,
        auth: true
      },
      {
        name: "create_payment_source",
        method: "post",
        endpointFn: (params) => `/api/v2/payment_sources/create_using_temp_token?hp_token=${params.hp_token}`,
        auth: true
      },
      {
        name: "remove_payment_source",
        method: "post",
        endpointFn: (params) => `/api/v2/payment_sources/${params.id}/delete`,
        auth: true
      },
      {
        name: "create_subscription_estimate",
        method: "get",
        endpointFn: (params) => `/api/v2/customers/${params.id}/create_subscription_estimate?hp_token=${params.hp_token}`,
        auth: true,
        set_locale: true
      },
      {
        name: "create_subscription",
        method: "post",
        endpointFn: (params) => `/api/v2/customers/${params.id}/subscriptions?hp_token=${params.hp_token}`,
        auth: true
      },
      {
        name: "update_billing_info",
        method: "post",
        endpointFn: (params) => `/api/v2/customers/${params.id}/update_billing_info?hp_token=${params.hp_token}`,
        auth: true
      },
      {
        name: "create_subscription_bulk",
        method: "post",
        endpointFn: (params) => `/api/internal/customers/${params.id}/subscriptions?hp_token=${params.hp_token}`,
        auth: true,
        headers: {
          "X-Requested-With": "XMLHttpRequest"
        }
      },
      {
        name: "invoices",
        method: "get",
        endpointFn: (params) => `/api/v2/invoices`,
        set_locale: true,
        auth: true
      },
      {
        name: "download_invoice",
        method: "post",
        endpointFn: (params) => `/api/v2/invoices/${params.invoiceId}/pdf`,
        auth: true
      },
      {
        name: "collect_payment",
        method: "post",
        endpointFn: (params) => `/api/v2/customers/${params.id}/collect_payment`,
        auth: true
      },
      {
        name: "collect_direct_debit_payment",
        method: "post",
        endpointFn: (params) => `/api/internal/customers/${params.id}/collect_payment?hp_token=${params.hp_token}`,
        auth: true,
        headers: {
          "X-Requested-With": "XMLHttpRequest"
        }
      }
    ]
  },
  {
    name: "field_configs",
    actions: [
      {
        name: "checkout",
        method: "get",
        ignore_locale: true,
        endpointFn: (params) => {
          return `/api/internal/configurations/1/retrieve?type=checkout_new&locale=${params.locale}`
        },
        headers: {
          "X-Requested-With": "XMLHttpRequest"
        }
      },
      {
        name: "portal",
        method: "get",
        ignore_locale: true,
        endpointFn: (params) => {
          return `/api/internal/portal_configurations/1/retrieve?locale=${params.locale}`
        },
        headers: {
          "X-Requested-With": "XMLHttpRequest"
        }
      },
      {
        name: "retrieve_init_info",
        method: "get",
        ignore_locale: true,
        endpointFn: (params) => {
          return `/api/internal/1/retrieve_init_info?locale=${params.locale}`
        },
        headers: {
          "X-Requested-With": "XMLHttpRequest"
        }
      }
    ]
  },
  {
    name: "style_configs",
    actions: [
      {
        name: "get",
        method: "get",
        endpoint: "/api/internal/retrieve_init_info",
        headers: {
          "X-Requested-With": "XMLHttpRequest"
        }
      }
    ]
  },
  {
    name: "comments",
    actions: [
      {
        name: "create",
        method: "post",
        auth: true,
        endpoint: "/api/v2/comments"
      }
    ]
  },
  {
    name: "auth_service",
    actions: [
      {
        name: "verify_otp",
        method: "post",
        endpoint: "/api/internal/ssp_users/verify_otp",
        set_locale:true,
        headers: {
          "X-Requested-With": "XMLHttpRequest"
        }
      },
      {
        name: "verify_password",
        method: "post",
        endpoint: "/api/internal/ssp_users/verify_password",
        set_locale:true,
        headers: {
          "X-Requested-With": "XMLHttpRequest"
        }
      },
      {
        name: "check_user",
        method: "post",
        endpoint: "/api/internal/ssp_users/check",
        headers: {
          "X-Requested-With": "XMLHttpRequest"
        }
      },
      {
        name: "check_user_checkout",
        method: "post",
        endpoint: "/api/internal/ssp_users/check_for_checkout",
        headers: {
          "X-Requested-With": "XMLHttpRequest"
        }
      },
      {
        name: "activate_sso_token",
        method: "post",
        endpoint: "/api/internal/ssp_users/activate_token",
        headers: {
          "X-Requested-With": "XMLHttpRequest"
        }
      },
      {
        name: "logout",
        method: "post",
        endpoint: "/api/internal/ssp_users/logout",
        headers: {
          "X-Requested-With": "XMLHttpRequest"
        }
      },
      {
        name: "clear_preview_cookie",
        method: "post",
        endpoint: "/hp_v3_settings/clear_cookie",
        headers: {
          "X-Requested-With": "XMLHttpRequest"
        }
      }
    ]
  },
  {
    name: "loggers",
    actions: [
      {
        name: "info_error",
        method: "post",
        endpoint: "/api/internal/track_info_error",
        headers: {
          "X-Requested-With": "XMLHttpRequest",
          'Content-Type': 'application/json',
        }
      },
      {
        name: "tokenization",
        method: "post",
        endpoint: "/hosted_pages/hp_v2_logger",
        headers: {
          "X-Requested-With": "XMLHttpRequest",
        }
      },
      {
        name: "hp_form",
        method: "post",
        endpointFn: (params) => `/api/internal/hosted_pages/${params.hp_token}/log?log_type=${params.log_type}`,
        headers: {
          "X-Requested-With": "XMLHttpRequest",
          'Content-Type': 'application/json',
        }
      }
    ]
  },
  {
    name: "vat_service",
    actions: [
      {
        name: "validate",
        method: "get",
        headers: {
          "X-Requested-With": "XMLHttpRequest",
        },
        endpoint: "/hosted_pages/validate_vat"
      }
    ]
  },
  {
    name: "gateway",
    actions: [
      {
        name: "retrieve",
        method: "get",
        headers: {
          "X-Requested-With": "XMLHttpRequest",
        },
        endpoint: "/api/internal/gateway/retrieve"
      }
    ]
  }
]

var getEndpoint = function(action, params) {
  if(action.endpoint) {
    return action.endpoint;
  }
  if(action.endpointFn) {
    var sanitizedParams = Object.keys(params).reduce((o, param) => {
      if(params[param]) {
        o[param] = encodeURIComponent(params[param]);
      }
      return o;
    }, {});
    return action.endpointFn(sanitizedParams);
  }
}

class CbClient {
  constructor() {
    this.restClient = new RestClient();
    var that = this;
    apis.forEach(api => {
      this[api.name] = { };
      api.actions.forEach(action => {
        this[api.name][action.name] = function(args) {
          var urlEndPoint = getEndpoint(action, Array.prototype.shift.apply(arguments));
          var finalArgs = [].slice.call(arguments);
          finalArgs.unshift(urlEndPoint);
          if(finalArgs.length == 1) {
            finalArgs.push({});
          }
          if(!action.ignore_locale && that.store){
            let bodyParams = finalArgs[finalArgs.length - 1];
            bodyParams['locale'] = that.store.state.config.init_info_locale;
          }
          var headers = {};
          if(action.headers && Object.keys(action.headers).length >= 0) {
            Object.assign(headers, action.headers);
          }

          if(that.store) {
            if(that.store.state.auth.page_type == "portal") {
              var jwt = that.store.state.auth.jwt;
              headers['Authorization'] = `Bearer ${jwt}`;
              headers['CbSource'] = 'viaCp';
            }
            else {
              if(action.auth && that.store.state.auth.authTokenType != "hp_token"){
                var jwt = that.store.state.auth.jwt;
                headers['Authorization'] =  `Bearer ${jwt}`;
              }
              else {
                if(that.store.state.auth.hpToken) {
                  var token = that.store.state.auth.hpToken
                  headers['Authorization'] = `Bearer hp_${token}`
                }
              }
            }
          }

          finalArgs.push(headers);

          return new Promise((resolve, reject) => {
            that.restClient[action.method].apply(that.restClient, finalArgs)
            .then(response => resolve(response.data))
            .catch((error) => {
              let cbError = new CbError(error.response.status, error.response.data, undefined, that.store);
              if(error.response.status == 401) {
                window.cbStorage.removeItem('cbt');
                if(that.store) {
                  that.store.dispatch('logout_user', cbError);
                }
                try {
                  if(error.response.config.url.endsWith("/activate_token")) {
                    reject(cbError);
                  }
                }
                catch(e){
                }
              }
              else {
                reject(cbError);
              }
            });
          });
        }
      })
    })
  }

  syncWithStore(store) {
    this.store = store;
  }
}

export default new CbClient();


// WEBPACK FOOTER //
// ./src/utils/cb-client.js